import React from 'react';
import InnerEmailList from '../../email/InnerEmailList';

class EmailTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
    <div className={`tab-pane fade ${tab === 'email' ? 'show active in' : ''}`}>
        <div className="row">
            <div className="col-md-12">
                <InnerEmailList id={this.props.id} type={this.props.type} {...this.props} 
                    reload={this.props.reload} />;
            </div>
        </div>
    </div>
    );
  }
}
export default EmailTab;